import React from 'react';
import { hashCode } from './String';
import SafePortMarker from './SafePortMarker';
import useMap from './useMap';
import { Palette } from './Palette';
const createSafePort = (safePort, map) => new google.maps.Circle({
    center: safePort.location,
    strokeColor: Palette.SafePort,
    strokeOpacity: 1.0,
    strokeWeight: 3,
    fillColor: Palette.SafePort,
    fillOpacity: 0.25,
    radius: safePort.radius,
    map,
});
function useSafePorts(safePorts, draggable, onDragEnd) {
    const { map } = useMap();
    const ref = React.useRef(new Map());
    const [refreshKey, setRefreshKey] = React.useState();
    const shapes = React.useRef(new Map());
    React.useEffect(() => {
        if (!map) {
            return;
        }
        const oldKeys = new Set([...shapes.current.keys()]);
        const newKeys = new Map(safePorts?.map((e) => [hashCode(JSON.stringify(e || '')), e]) || []);
        let updated = false;
        [...oldKeys]
            .filter((e) => !newKeys.has(e))
            .forEach((e) => {
            ref.current.delete(e);
            shapes.current?.get(e)?.setMap(null);
            shapes.current?.delete(e);
            updated = true;
        });
        [...newKeys]
            .filter((e) => !oldKeys.has(e[0]) || !shapes.current.has(e[0]))
            .forEach((e) => {
            const key = e[0];
            const object = e[1];
            if (!object?.location) {
                return;
            }
            ref.current.set(key, object);
            const newObject = createSafePort(object, map);
            shapes.current.set(key, newObject);
            updated = true;
        });
        if (updated) {
            setRefreshKey(Math.random());
        }
    }, [safePorts, shapes, map]);
    const markers = React.useMemo(() => [...ref.current.values()]?.map((safePort) => (React.createElement(SafePortMarker, { key: safePort.id, draggable: draggable, onDragEnd: onDragEnd ? (coords) => onDragEnd(safePort.id, coords) : undefined, position: safePort.location, safePortId: safePort.id }))), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ref, refreshKey, draggable, onDragEnd]);
    return { markers };
}
export default useSafePorts;
